(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["green-coffee-estate-story"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const sectionId = '{{ section.id }}';
    const muteToggle = document.querySelector('[data-mute-toggle="' + sectionId + '"]');
    const videoElement = document.querySelector('[data-video-element="' + sectionId + '"]');
    const muteText = document.querySelector('[data-mute-text="' + sectionId + '"]');

    if (muteToggle && videoElement && muteText) {
      // Set initial text
      muteText.textContent = videoElement.muted ? 'Unmute' : 'Mute';

      // Toggle mute on click
      muteToggle.addEventListener('click', function(e) {
        e.preventDefault();
        videoElement.muted = !videoElement.muted;
        muteText.textContent = videoElement.muted ? 'Unmute' : 'Mute';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
